var map = {
	"./2019.json": [
		362,
		1
	],
	"./2020.json": [
		363,
		2
	],
	"./2021.json": [
		364,
		3
	],
	"./2022.json": [
		365,
		4
	],
	"./2023.json": [
		366,
		5
	],
	"./2024.json": [
		367,
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 358;
module.exports = webpackAsyncContext;